import * as React from 'react'
import styled from '@emotion/styled'
import Link from 'next/link'

import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded'
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutlineRounded'
import PublicRoundedIcon from '@mui/icons-material/PublicRounded'
import Box, { BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

import Routes from 'utils/routes'
import { useRouter } from 'next/router'

export const NavbarPixelHeight = 42

const StyledAppBar = styled(Box)`
    box-shadow: none;
    /* background: ${({ theme }) => theme.palette.background.default}; */
    /* border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`}; */
    height: ${NavbarPixelHeight}px;
    display: flex;
    align-items: center;
`

const HeaderBar = (props: BoxProps) => {
    const router = useRouter()

    const isCurrentRoute = React.useCallback((route: string) => route === router.pathname, [router.pathname])

    return (
        <StyledAppBar sx={props.sx}>
            <ResponsiveContainer maxWidth="xl">
                <Stack direction="row" spacing={1} alignItems={'center'}>
                    <Text fontWeight={'bold'} display={{ xs: 'none', sm: 'flex' }} sx={{ marginRight: 1 }}>
                        Wiki
                    </Text>
                    {/* <Link href={Routes.WikiSubjects}>
                        <a>
                            <Button
                                variant="text"
                                color="inherit"
                                size="small"
                                startIcon={<SubjectRoundedIcon fontSize="small" color="primary" />}>
                                Argomenti
                            </Button>
                        </a>
                    </Link> */}
                    <Link href={Routes.WikiTools}>
                        <a>
                            <Button
                                variant="text"
                                color={isCurrentRoute(Routes.WikiTools) ? 'primary' : 'inherit'}
                                size="small"
                                sx={{ paddingX: 1 }}
                                startIcon={<ConstructionRoundedIcon fontSize="inherit" color="inherit" />}>
                                Tool
                            </Button>
                        </a>
                    </Link>
                    <Link href={Routes.WikiLanguages}>
                        <a>
                            <Button
                                variant="text"
                                color={isCurrentRoute(Routes.WikiLanguages) ? 'primary' : 'inherit'}
                                size="small"
                                sx={{ paddingX: 1 }}
                                startIcon={<PublicRoundedIcon fontSize="inherit" color="inherit" />}>
                                Linguaggi
                            </Button>
                        </a>
                    </Link>
                    <Link href={Routes.WikiRoles}>
                        <a>
                            <Button
                                variant="text"
                                color={isCurrentRoute(Routes.WikiRoles) ? 'primary' : 'inherit'}
                                size="small"
                                sx={{ paddingX: 1 }}
                                startIcon={<WorkOutlineRoundedIcon fontSize="inherit" color="inherit" />}>
                                Professioni
                            </Button>
                        </a>
                    </Link>
                </Stack>
            </ResponsiveContainer>
        </StyledAppBar>
    )
}

export default HeaderBar
